
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationText } from '@/components/i18n/TranslationText';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Quote } from 'lucide-react';

export function TestimonialsSection() {
  const { t } = useTranslation();
  
  const testimonials = [
    {
      quote: "testimonials.quote1",
      author: "testimonials.author1",
      role: "testimonials.role1",
      company: "testimonials.company1",
      image: "/images/avatar1.jpg",
    },
    {
      quote: "testimonials.quote2",
      author: "testimonials.author2",
      role: "testimonials.role2",
      company: "testimonials.company2",
      image: "/images/avatar2.jpg",
    },
    {
      quote: "testimonials.quote3",
      author: "testimonials.author3",
      role: "testimonials.role3",
      company: "testimonials.company3",
      image: "/images/avatar3.jpg",
    },
  ];
  
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900">
      <div className="container px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mb-4">
            <TranslationText i18nKey="testimonials.title">
              Trusted by Businesses Across Norway
            </TranslationText>
          </h2>
          <p className="text-muted-foreground md:text-lg">
            <TranslationText i18nKey="testimonials.subtitle">
              See what our customers have to say about Subtrackr
            </TranslationText>
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden animate-fade-in" style={{ animationDelay: `${index * 150}ms` }}>
              <CardContent className="p-6">
                <Quote className="h-8 w-8 text-primary mb-4 opacity-70" />
                <p className="text-lg mb-6 italic">
                  <TranslationText i18nKey={testimonial.quote}>
                    {t(testimonial.quote)}
                  </TranslationText>
                </p>
                <div className="flex items-center">
                  <Avatar className="h-12 w-12 mr-4">
                    <AvatarImage src={testimonial.image} alt={t(testimonial.author)} />
                    <AvatarFallback>
                      {t(testimonial.author).split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-medium">
                      <TranslationText i18nKey={testimonial.author}>
                        {t(testimonial.author)}
                      </TranslationText>
                    </p>
                    <p className="text-sm text-muted-foreground">
                      <TranslationText i18nKey={testimonial.role}>
                        {t(testimonial.role)}
                      </TranslationText>
                      , <TranslationText i18nKey={testimonial.company}>
                        {t(testimonial.company)}
                      </TranslationText>
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
